import { Tooltip } from "@material-ui/core";
import React, { useState } from "react";
import { ModalItem } from "./ModalItem";
import { useTooltipCommonStyles } from "../styles";
import { openTooltip } from "../helpers";
import { IRefundTransaction, IRefundTransactionProduct } from "../contracts";

export function TransactionModal({ row }) {
    const [open, setOpen] = useState<boolean>(false);
    const tooltipClass = useTooltipCommonStyles();
    const pbmSales: IRefundTransaction = row?.original;
    const pbmSalesProducts: IRefundTransactionProduct[] = pbmSales.pbmSalesProducts;
    const style: React.CSSProperties = {
        display: "flex", 
        flex: "1", 
        padding: "5px", 
        justifyContent: "space-between", 
        maxHeight: "100px", 
        overflowY: "auto"
    };
    
    if (pbmSalesProducts?.length > 1) {
        const modal = 
            <div style={style}>
                <ModalItem pbmSales={pbmSales} item = {"productCode"} title = {"EAN"} style={{width: "180px"}}/>
                <ModalItem pbmSales={pbmSales} item = {"productName"} title = {"PRODUTO"} style={{width: "180px"}}/>
                <ModalItem pbmSales={pbmSales} item = {"refundStatus"} title = {"STATUS DO PROCESSAMENTO"} style={{width: "220px"}}/>
                <ModalItem pbmSales={pbmSales} item = {"refundAmount"} title = {"RESSARCIMENTO"} style={{width: "220px"}}/>
            </div>;

        return (
            <Tooltip classes={{tooltip: tooltipClass.customTooltip}} title= { modal } arrow placement="left" leaveDelay={1000} disableFocusListener
            disableHoverListener
            open={open}
            disableTouchListener>
                <a onClick={() => openTooltip(open, setOpen)} style={{cursor: "pointer", fontSize: "26px", height: "20px"}}>{ open ? "x" : "..."}</a>
            </Tooltip> 
        );
    } 

    return <span>{pbmSalesProducts ?  "" : "carregando..."}</span>;
}